import React from 'react';
import { RefreshCcw, Check } from 'lucide-react'; // Sun から RefreshCcw と Check に変更

/**
 * TodayChallengeQuizSection コンポーネントのProps型定義
 */
interface TodayChallengeQuizSectionProps {
  reviewCount: number; // レビュー待ちのクイズ数
  onClick: () => void; // クリック時のイベントハンドラ
}

/**
 * 今日のチャレンジクイズセクションコンポーネント
 * @param reviewCount - おすすめクイズの数
 * @param onClick - クリックイベントハンドラ
 */
const TodayChallengeQuizSection: React.FC<TodayChallengeQuizSectionProps> = ({ reviewCount, onClick }) => {
  const buttonText =
    reviewCount > 0
      ? `復習問題！ (${reviewCount}問)`
      : '復習問題はありません';

  const isDisabled = reviewCount === 0;

  return (
    <div className="flex justify-center mt-6">
      <button
        onClick={onClick}
        disabled={isDisabled}
        className={`py-4 px-10 bg-custom-gradient from-violet-500 to-purple-500 text-white rounded-full font-bold text-xl shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center ${isDisabled
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:from-violet-600 hover:to-purple-600 animate-pulse'
          }`}
      >
        {/* Sunアイコンを削除し、RefreshCcwとCheckアイコンを組み合わせる */}
        {/* 親要素を相対配置、子アイコンを絶対配置して重ねています */}
        <span className="relative w-8 h-8 flex items-center justify-center mr-3">
          <RefreshCcw size={28} className="absolute text-white" />
          <Check size={16} className="absolute text-white" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
        </span>
        {buttonText}
      </button>
    </div>
  );
};

export default TodayChallengeQuizSection;
